/* eslint-disable max-len */
import React from 'react';
import facebook from '../../assests/facebook.png';
import google from '../../assests/google.png';

const ReviewComponent = ({
  getData, handleReviewActivity, setPage, page, typePage,
}) => (
  <div className="qs-fade-in space-y-8">
    <div className="space-y-3">
      <div className="qs-title">
        How was your experience?
      </div>
      <div className="qs-subtitle mx-auto max-w-[480px]">
        Thank you for choosing us! Please take a moment to leave us a review. Your responses will help us serve you better in the future.
      </div>
    </div>
    <div className="space-y-3">
      <div className="flex justify-center empty:hidden">
        {getData?.review_site_1_url !== null && (
          <button
            className="qs-btn"
            type="button"
            style={{
              backgroundColor: '#4CAF50',
              color: '#FFFFFF',
            }}
            onClick={() => handleReviewActivity(getData?.review_site_1_platform,'google_type')}
          >
            <a href={getData?.review_site_1_url}>
              <div className="flex items-center justify-center gap-3">
                <img
                  src={google}
                  alt={getData?.review_site_1_platform}
                  className="h-7 w-7 shrink-0 rounded-md bg-white object-contain p-0.5"
                />
                <span>
                  Review us on Google
                </span>
              </div>
            </a>
          </button>
        )}
      </div>

      <div className="flex justify-center empty:hidden">
        {getData?.review_site_2_url !== null && (
          <button
            className="qs-btn"
            type="button"
            style={{
              backgroundColor: '#4CAF50',
              color: '#FFFFFF',
            }}
            onClick={() => handleReviewActivity(getData?.review_site_2_platform,'facebook_type')}
          >
            <a href={getData?.review_site_2_url}>
              <div className="flex items-center justify-center gap-3">
                <img
                  src={facebook}
                  alt={getData?.review_site_2_platform}
                  className="h-7 w-7 shrink-0 rounded-md bg-white object-contain p-0.5"
                />
                <span>
                  Review us on Facebook
                </span>
              </div>
            </a>
          </button>
        )}
      </div>

    </div>
  </div>

);

export default ReviewComponent;
